import { render } from "./xjadd.vue?vue&type=template&id=0556e5ee&scoped=true"
import script from "./xjadd.vue?vue&type=script&lang=js"
export * from "./xjadd.vue?vue&type=script&lang=js"

import "./xjadd.vue?vue&type=style&index=0&id=0556e5ee&lang=scss&scoped=true"
import "./xjadd.vue?vue&type=style&index=1&id=0556e5ee&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0556e5ee"]])

export default __exports__